import React, {PureComponent} from 'react';
import axios from "axios";
import jwt_decode from 'jwt-decode';
import {Spinner} from "react-bootstrap";
import {AuthenticationContext} from "../services/context/authentication.context";
import { LOCAL_STORAGE_KEYS } from 'common/constants/localStorageKeys';
import { isMobile, redirectToLogin } from 'helpers';
import AuthenticationService from 'services/authentication.service';
import { PageProps } from 'models/page';

interface RedirectLoaderState {
    token: string | null;
    loading: boolean;
    validatedRedirect: boolean | null;
    customerId: string | null;
    userId: string | null;
}

export default class RedirectLoader extends PureComponent<PageProps, RedirectLoaderState> {

    static contextType = AuthenticationContext;
    constructor(props: PageProps) {
        super(props);
        this.props.onLoadValidatePage();
        const token = new URLSearchParams(props.location.search).get("token");
        let customerId = null;
        let userId = null;
        if (token != null) {
            const jwtDecode: any = jwt_decode(token);
            userId = jwtDecode.sub;
            customerId = jwtDecode.referred_customer_id;
            localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTHORIZATION_HEADER);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ID);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
        }

        this.state = {
            token: token,
            loading: true,
            validatedRedirect: null,
            customerId,
            userId
        };
    }


    handleRedirectLogin = (token: string) => {
        initRedirectLogin(token).then((response: string) => {
            if (response) {
               this.handleSuccessfulLogin();
            } else {
                this.setState({
                    ...this.state,
                    loading: false,
                    validatedRedirect: false
                })
            }
        }).catch(reason => {
            this.setState({
                ...this.state,
                loading: false,
                validatedRedirect: false
            });
            localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTHORIZATION_HEADER);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ID);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);

            redirectToLogin();
        })
    };

    handleSuccessfulLogin = () => {
        if (localStorage.getItem(LOCAL_STORAGE_KEYS.AUTHORIZATION_HEADER) && localStorage.getItem(LOCAL_STORAGE_KEYS.USER_ID)) {
            const token = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTHORIZATION_HEADER);
            const userId = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_ID);

            localStorage.setItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID, this.state.customerId ?? userId ?? '');

            this.setState({
                ...this.state,
                loading: false,
                validatedRedirect: true
            });
            this.context.dispatch({
                type: "setCustomerId",
                value: this.state.customerId
            });
            this.context.dispatch({
                type: "setUserId",
                value: this.state.userId
            });                
            this.context.dispatch({
                type: "setAuthenticated",
                value: true
            });
            this.context.dispatch({
                type: "setToken",
                value: token
            })
            this.props.history.replace('/esileht')
        }
    }

    componentDidMount(): void {
        AuthenticationService.logout();
        localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTHORIZATION_HEADER);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_ID);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
        this.context.dispatch({
            type: "setUserId",
            value: null
        });
        setTimeout(() => {
            this.handleRedirectLogin(this.state.token as string)
        }, 50);
    }

    render() {
        return (
                <div className="d-flex">
                    {
                        this.state.loading &&
                        <div className="m-auto">
                            <Spinner animation={"grow"}/>
                        </div>
                    }
                </div>
        );
    }
}

async function initRedirectLogin(token: string): Promise<string> {
    const baseUrl = process.env.REACT_APP_API_URL;
    return new Promise((resolve, reject) => {
        axios.post(
            baseUrl + "/v1/auth/redirect-login", token,
            {
                withCredentials: true,
                headers: {
                    "x-with-app": isMobile(),
                    "content-type": "application/json"
                }
            }).then(
            response => {
                resolve(response.data.data)
            }
        ).catch(error => {
            if (error.response) {
                reject(error.response.status)
            } else {
                reject(500)
            }
        });
    });
}
